import { render } from "./form_index.vue?vue&type=template&id=607fdda6&scoped=true"
import script from "./form_index.js?vue&type=script&lang=js"
export * from "./form_index.js?vue&type=script&lang=js"

import "./form_index.vue?vue&type=style&index=0&id=607fdda6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607fdda6"]])

export default __exports__